export const APP_VERSION = '3.6.8';
export const PACKAGE_ID = 'au.com.weguide';
export const APP_STORE_ID = 'id1544070103';
export const SCHEME_URL = 'weguide://';
export const PIN_FEATURE: 'optional' | 'off' = 'off';
export const PIN_LENGTH = 6;
export const VIDEO_RECORDING_QUALITY: 0 | 1 | 2 = 1; // for 0 as low , 1 as medium and 2 as high
export const DEFAULT_TENANT = '';
export const PROGRAM_CODE = true;
export const TENANT_ID = 'weguide';
export const TENANT_NAME = 'WeGuide';
export const TENANT_TAB = '';
export const LABEL_TASK_OVERVIEW = 'YourActionsPage.title';
export const LABEL_TASK = 'YourActionsPage.fill-in';
export const APP_STORE_REDIRECT = `https://apps.apple.com/in/app/${TENANT_NAME}/${APP_STORE_ID}`;
export const PLAY_STORE_REDIRECT = `https://play.google.com/store/apps/details?id=${PACKAGE_ID}`;
export const LEARN_MORE_URL = 'https://www.weguide.health';
export const LOGO = '/assets/weguide-logo.svg';
export const ANIMATIONS_PATH = '/assets/animations/';
export const LANDING_SLIDES = [
  {
    header: 'WeGuide.slide2Header',
    text: 'WeGuide.slide2Text',
    image: 'your-digital-companion.svg',
  },
  {
    header: 'WeGuide.slide3Header',
    text: 'WeGuide.slide3Text',
    image: 'quick-and-easy.svg',
  },
];
export const JOURNEY_PROGRAMS: any = [];

export const REFERRAL_CODES = [];
export const REFERRAL_CODES_2 = [];
export const GOAL_TAB_LABEL = 'TabsPage.myGoals';
export const GOAL_PAGE_HEADER = 'GoalsPage.title';
export const HOME_TAB_LABEL = 'TabsPage.home';
export const INFORMATION_TAB_LABEL = 'TabsPage.program-info';
export const INFORMATION_PAGE_HEADER = 'ProgramInfoPage.title';
export const WELCOME_PAGE_HEADER = 'WelcomePage.title';
export const COMPLETED_HEADER = 'YourActionsPage.completedHeader';

export const SUPPORTED_LANGUAGES = []; // empty means all languages are supported

/* Features */
export const ECG_FEATURE = true;
export const PASSPORT_FEATURE = false;
export const PROGRAM_INFO = true;
export const MULTI_LANGUAGE = true;
export const DATES_FILTER = false;
export const HIDE_SIGNUP_BUTTON = false;

export const HIDE_LANGUAGE_PICKER = !MULTI_LANGUAGE;
export const HIDE_COMMUNICATION_PREF = false;
export const HIDE_JOIN_ADD_PROG = false;
export const HIDE_RECEIVE_MSG_OUTSTANDING = false;
export const NEXT_TASK_AVAILABLE = true;
export const SHOW_NONE_COMM_PREFERENCE = false;
